<template>
    <!-- <source  type="video/mp4" /> -->
    <div id="login" class="login" ref='page'>
        <div class="login_bg" ref="bg">
            <span>正蓝旗肉牛产业数字化平台</span>
            <div class="bg_1">
                <div class="bg_2">
                    <h3>欢迎登录</h3>
                    <div class="input">
                        <!-- <img src="../assets/user_icon.png"> -->
                        <img src="../assets/user_icon_2.png">
                        <input type="text" placeholder='请输入用户名' v-model="username" @keyup.enter="login">
                    </div>
                    <div class="input pass">
                        <!-- <img src="../assets/password_icon.png"> -->
                        <img src="../assets/user_password_2.png">
                        <input type="password" placeholder='请输入密码' v-model="password" @keyup.enter="login">
                    </div>
                    <div class="input">
                        <!-- <img src="../assets/code_icon.png"> -->
                        <img src="../assets/user_code_2.png">
                        <input type="text" placeholder='请输入验证码' v-model="code" maxLength="6" @keyup.enter="login">
                        <img :src="codeApi" @click="updateId" class="code">
                    </div>
                    <div class="btn" @click="login">
                        登录
                    </div>
                </div>
                <div class="bg_son"></div>
            </div>
            <video src="../assets/login-bg-2.mp4" autoplay="autoplay" loop class="fillWidth" muted='muted'>
            </video>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            username: '',
            password: '',
            code: '',
            flag: true,
            clientWidth: window.screen.width,
            screenHeight: window.screen.height,
            clientHeight: window.document.documentElement.clientHeight,
            randomNum: '',
            myKey: '',
            deptId:''
        };
    },
    components: {
    },
    computed: {
        codeApi() {
            return '//yj.east-mind.com:8098/Capture/GetValidatorCode.aspx?w=120&h=30&c=' + this.updateId()
        },
    },
    watch: {
        clientHeight() {     //如果screenHeight 发生改变，这个函数就会运行
            this.changeFixed(this.clientWidth, this.screenHeight)
        }
    },
    mounted() {
        this.changeFixed(this.clientWidth, this.screenHeight)
        window.onresize = () => {
            this.clientHeight = window.document.documentElement.clientHeight
        }
    },
    methods: {
        changeFixed(clientWidth, screenHeight) {
            if (this.$refs.page && (clientWidth / screenHeight > 1.7) && (clientWidth / screenHeight < 1.8)) {
                this.$refs.page.style.maxWidth = clientWidth + 'px';
                this.$refs.page.style.maxHeight = this.clientHeight + 'px';
                this.$refs.bg.style.maxWidth = clientWidth + 'px';
                this.$refs.bg.style.maxHeight = this.clientHeight + 'px';
            } else {
                this.$refs.page.style.maxWidth = 0 + 'px';
                this.$refs.page.style.maxHeight = 0 + 'px';
                this.$refs.bg.style.maxWidth = 0 + 'px';
                this.$refs.bg.style.maxHeight = 0 + 'px';
                this.$refs.page.style.maxWidth = 1920 + 'px';
                this.$refs.page.style.maxHeight = 1080 + 'px';
                this.$refs.bg.style.maxWidth = 1920 + 'px';
                this.$refs.bg.style.maxHeight = 1080 + 'px';
            }
        },
        updateId() {
            const arr = []
            for (var i = 0; i < 6; i++) {
                arr.push(Math.round(Math.random() * 9))
            }
            this.randomNum = arr.join('')
            return this.randomNum;
        },
        login() {
            if (!this.username) {
                this.$message.error('请输入用户名');
                return;
            }
            if (!this.password) {
                this.$message.error('请输入密码');
                return;
            }
            if (!this.code) {
                this.$message.error('请输入验证码');
                return;
            }
            if (this.code != this.randomNum) {
                this.$message.error('请输入正确的验证码');
                return;
            }
            if (!this.flag) {
                return
            }
            this.flag = false;

            // var formData=new FormData();
            // formData.append('username',this.username);
            // formData.append('password',this.password);
            // formData.append('code',this.code);
            // this.$axios.get('/api.asmx/Login', formData).then(res => {
            //     this.flag = true
            //     console.log(res)
            // })
            this.$http({
                url: '/xmbapp-service/user/login',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    username: this.username,
                    password: this.password,
                    extsysCode: 100000010
                },
            }).then(res => {
                this.flag = true
                const data = res.data;
                if (res.data.code === 200) {
                    window.localStorage.setItem('LOGIN', '/nmzlqlogin')
                    window.localStorage.setItem('NMYDATAAUSERNAME', this.username)
                    window.localStorage.setItem('NMYDATAASSTSTOKEN', data.result.token)
                    window.localStorage.setItem('NMYDATAUSERINFO', JSON.stringify(data.result.sysUser))
                    this.updateId()
                    this.getDeptId()
                    // this.$router.push({ name: "operate" })
                } else {
                    this.$message.error(data);
                }
            })
        },
        getDeptId() {
            this.$http({
                url: '/screenapp-service/loginContrast/find',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    code: 2,
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                   this.deptId=data.result.deptId
                    this.getInfo()
                    window.localStorage.removeItem('ADDRESS')
                    window.localStorage.setItem('ADDRESS', JSON.stringify(['150000', '152500', '152530']))
                } else {
                    this.$message.error(data);
                }
            })
        },
        getInfo() {
            this.$http({
                url: '/admin-service/getInfo',
                //请求方式
                method: 'get',
                //传递的参数
                data: {
                    extsysCode: 100000010
                },
            }).then(res => {
                this.flag = true
                const data = res.data;
                if (res.data.code === 200) {
                    this.myKey = data.permissions[0]
                    console.log(data.permissions[0])
                    if (data.permissions && data.permissions.length > 0) {
  if(data.permissions.includes('screen:provincescreen:list')) {
                            if (data.user.deptId !== this.deptId) {//开发
                                    this.$message.error('非本系统账号！');
                                } else {
                                    this.$router.push({ name: "operate" })
                                }
                        } else if(data.permissions.includes('screen:groupScreen:list')) {
                            this.$router.push({ name: "general", params: { myKey: 'screen:groupScreen:list' } })
                        } else if(data.permissions.includes('screen:areapartner:list')) {
                            this.$router.push({ name: "partner" })
                        } else if(data.permissions.includes('system:data:app')) {
                            this.$router.push({ name: "partner" })
                        } else {
                            this.$message.error('没有访问权，请联系管理员111！');
                        }
                       /*  switch (data.permissions[0]) {
                            case 'screen:provincescreen:list':
                                if (data.user.deptId !== this.deptId) {//开发
                                    this.$message.error('非本系统账号！');
                                } else {
                                    this.$router.push({ name: "operate" })
                                }
                                // if (data.user.deptId !== '1600017400996753411') {//测试
                                //     this.$message.error('非本系统账号！');
                                // } else {
                                //     this.$router.push({ name: "operate" })
                                // }
                                break;
                            case 'screen:groupScreen:list':
                                this.$router.push({ name: "general", params: { myKey: 'screen:groupScreen:list' } })
                                break;
                            case 'screen:areapartner:list':
                                this.$router.push({ name: "partner" })
                                break;
                            case 'system:data:app'://匹配生产环境
                                this.$router.push({ name: "partner" })
                                break;
                            default:
                                this.$message.error('没有访问权，请联系管理员！');
                        } */
                    } else {
                        this.$message.error('没有访问权，请联系管理员！');
                    }
                } else {
                    this.$message.error(data);
                }
            })
        }
    }
};
</script>

<style lang="scss" >
@import "../assets/scss/index.scss";
</style>
<style lang="scss" scoped>
#app {
    .silder {
        .silderShow {
            display: none;
        }
    }
}

.login {
    color: #d3d6dd;
    // background-color: #000000;
    // height: 100%;
    width: 100%;
    max-width: 1920px;
    height: 100vh;
    max-height: 1080px;
    margin: 0 auto;

    .login_bg {
        // height: 100%;
        width: 100%;
        max-width: 1920px;
        height: 100vh;
        max-height: 1080px;
        padding: 0.2rem 0.2rem 0 0.2rem;
        // background-image: url("../assets/login_bg.png");
        background-size: 100% 100%;
        background-position: center center;

        span {
            position: absolute;
            // top: .89rem;
            // left: 30%;
            top: 10%;
            left: 35%;
            z-index: 10;
            display: block;
            width: 11.4rem;
            height: 0.4rem;
            font-size: 0.6rem;
            font-family: PingFang SC-特粗, PingFang SC;
            // font-weight: normal;
            font-weight: 700;
            color: #FFFFFF;
            line-height: 0.4rem;
        }
    }
}

.bg_1 {
    position: absolute;
    z-index: 999;
    // width: 8.54rem;
    // height: 6.26rem;
    left: 50%;
    top: 50%;
    transform: translate(-4rem, -3rem);
    width: 8rem;
    height: 6rem;
    // margin: 2.75rem auto 0;
    // background-image: url("../assets/login_bg_1.png");
    // background-image: url("../assets/login_05.png");
    background: rgba(0, 0, 0, 0.5);
    background-size: 100% 100%;
    background-position: center center;
    padding: 0.23rem 0.33rem 0.2rem;

    &::after {
        position: absolute;
        left: 0;
        top: 0;
        content: "";
        width: 0.3rem;
        height: 0.3rem;
        border-left: 5px solid #00E4FF;
        ;
        border-top: 5px solid #00E4FF;
        ;

    }

    &::before {
        position: absolute;
        right: 0;
        top: 0;
        content: "";
        width: 0.3rem;
        height: 0.3rem;
        border-right: 5px solid #00E4FF;
        ;
        border-top: 5px solid #00E4FF;
        ;

    }

    .bg_son {
        width: 8rem;
        height: .3rem;
        position: absolute;
        left: 0;
        bottom: 0;

        &::after {
            position: absolute;
            left: 0;
            bottom: 0;
            content: "";
            width: 0.3rem;
            height: 0.3rem;
            border-left: 5px solid #00E4FF;
            ;
            border-bottom: 5px solid #00E4FF;
            ;

        }

        &::before {
            position: absolute;
            right: 0;
            bottom: 0;
            content: "";
            width: 0.3rem;
            height: 0.3rem;
            border-right: 5px solid #00E4FF;
            ;
            border-bottom: 5px solid #00E4FF;
            ;

        }
    }
}

.bg_2 {
    // width: 7.89rem;
    // height: 5.84rem;
    width: 7.3rem;
    height: 5.6rem;
    // background-image: url("../assets/login_bg_2.png");
    background-size: 100% 100%;
    background-position: center center;
    padding-top: 0.76rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    h3 {
        height: 0.45rem;
        font-size: 0.45rem;
        color: #FFFFFF;
        letter-spacing: 5px;
        text-align: center;
        margin-bottom: .4rem;
        font-weight: 400 !important;
    }

    .input {
        width: 4.96rem;
        height: 0.73rem;
        // background-image: url("../assets/input_bg.png");
        // background: #1a2336;
        border: 1px solid #fff;
        border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
        opacity: 0.5;

        background-size: 100% 100%;
        background-position: center center;
        display: flex;
        align-items: center;
        padding: 0 0.28rem;

        img {
            width: 0.44rem;
            height: 0.44rem;
            margin-right: 0.11rem;
            filter: brightness(100%);
        }

        input {
            flex: 1;
            height: 80%;
            background: transparent;
            // background: #FFFFFF;
            border: none;
            // color: #05E9F7;
            // color: #969696;
            color: #FFFFFF;
            font-size: 0.2rem;
            letter-spacing: 2px;
        }

        input::-webkit-input-placeholder {
            // color: #58C9D2;
            // color: #969696;
            color: #FFFFFF;
        }

        .code {
            // width: 0.93rem;
            // height: 0.38rem;
            width: 1.5rem;
            height: 0.5rem;
            cursor: pointer;
        }
    }

    .input.pass {
        margin: 0.23rem 0;
    }

    .btn {
        width: 4.94rem;
        height: 0.73rem;
        display: flex;
        align-items: center;
        justify-content: center;
        // background-image: url("../assets/btn_bg.png");
        background: linear-gradient(360deg, #00E0DB 0%, #04E1DD 100%);
        opacity: 1;
        border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
        background-size: 100% 100%;
        background-position: center center;
        display: flex;
        align-items: center;
        font-size: 0.23rem;
        color: #FFFFFF;
        line-height: 0.3rem;
        letter-spacing: 1px;
        margin-top: 0.38rem;
        cursor: pointer;
    }
}

.fillWidth {
    width: 100%;
    height: 100%;
    object-fit: fill;
    position: absolute;
    top: 0;
    left: 0;
}
</style>
